import { IRecruitSFilter } from 'src/@types/SearchFilterTypes';
import { IRecruit } from 'src/models';
import { TApiResponseData } from 'src/service/apiTypes';
import instance from 'src/service/axios';
import objectToQueryString from 'src/utils/objectToQueryString';

const SUB_URL = '/v1/recruit';

/**
 * 목록 조회
 */
export const getRecruit = async (formData: IRecruitSFilter) => {
  try {
    const url = SUB_URL + objectToQueryString(formData);
    const response = await instance.get<TApiResponseData<IRecruit[]>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
        pagination: response.data.pagination,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 상세 조회
 */
export const getDetail = async (recruitSid: number) => {
  try {
    const url = `${SUB_URL}/${recruitSid}`;
    const response = await instance.get<TApiResponseData<IRecruit>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 수정 ( = 결과 저장 및 수정)
 */
export const put = async (data: {
  recruitSid: number;
  recruitStatusCd: number | string;
  memo: string;
}) => {
  try {
    const url = `${SUB_URL}/${data.recruitSid}`;

    const response = await instance.put<TApiResponseData<IRecruit>>(url, data);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 삭제
 */
export const remove = async (recruitSid: number) => {
  try {
    const url = `${SUB_URL}/${recruitSid}`;
    const response = await instance.delete<TApiResponseData<IRecruit>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 지원서 다운로드
 */
export const downloadFile = async (attachment: {
  recruitSid: number;
  fileNm: string;
  filePath: string;
  isZipFile: boolean;
}) => {
  try {
    const url = attachment.isZipFile
      ? `${SUB_URL}/${attachment.recruitSid}/download/zip`
      : `${SUB_URL}/${attachment.recruitSid}/download?filePath=${attachment.filePath}`;

    const response = await instance.get(url, {
      headers: { 'Content-Type': 'application/octet-stream' },
      responseType: 'blob',
    });

    if (response.data) {
      const blob = new Blob([response.data], {
        type: response.headers['content-type'] || 'application/octet-stream',
      });
      const downloadUrl = window.URL.createObjectURL(blob);

      // 가상 링크 생성 + 클릭
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', attachment.fileNm || 'downloaded_file');
      document.body.appendChild(link);
      link.click();

      // URL 해제 및 링크 제거
      setTimeout(() => {
        window.URL.revokeObjectURL(downloadUrl);
        link.remove();
      }, 100);
    }
  } catch (error) {
    console.error('파일 다운로드 실패:', error);
  }
};
